// src/components/Header.js
import React from "react";
import { Helmet } from "react-helmet";
import profilePic from "../assets/images/profile-pic.jpg";
import "../assets/styles/header.css";
import { Typography } from "@mui/material";

const Header = () => {
  return (
    <header className="header">
      <Helmet>
        <title>Abhishek Kadian</title>
        <meta name="description" content="Abhishek Kadian's website." />
        <meta property="og:title" content="Abhishek Kadian" />
        <meta property="og:description" content="Abhishek Kadian's website." />
        <meta
          property="og:image"
          content="https://abhiskk.github.io/static/media/profile-pic.bf6957221a64a3077165.jpg"
        />
        <meta property="og:url" content="https://abhiskk.github.io" />
      </Helmet>
      <div className="header-content-container">
        <div className="header-content">
          <div className="header-wrapper">
            <div className="inner-container">
              <img
                src={profilePic}
                alt="Abhishek Kadian"
                className="profile-pic"
              />
              <div className="text-container">
                <Typography
                  variant="h2"
                  style={{
                    fontFamily: "Lato",
                    display: "inline",
                    fontSize: { xs: "22px", sm: "44px" },
                    lineHeight: 1.5,
                  }}
                >
                  Abhishek Kadian
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    fontFamily: "Lato, sans-serif",
                    marginTop: "-3px",
                    fontSize: { xs: "14px", sm: "18px" },
                  }}
                >
                  Research Engineer
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    fontFamily: "Lato, sans-serif",
                    marginTop: "-3px",
                    fontSize: { xs: "14px", sm: "18px" },
                  }}
                >
                  Meta
                </Typography>
                <div className="contact-icons">
                  <a
                    href="mailto:abhishekkadiyan@gmail.com"
                    className="email-icon"
                  >
                    <i className="fas fa-envelope" aria-hidden="true"></i>
                  </a>
                  <a
                    href="https://github.com/abhiskk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="github-icon"
                  >
                    <i className="fa fa-github" aria-hidden="true"></i>
                  </a>
                  <a
                    href="https://scholar.google.com/citations?hl=en&user=wjJnkcAAAAAJ"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="google-scholar-icon"
                  >
                    <i className="ai ai-google-scholar" aria-hidden="true"></i>
                  </a>
                  <a
                    href="https://twitter.com/abhisk_kadian"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="twitter-icon"
                  >
                    <i className="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            {/* Theme toggle removed */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
